<template>
    <div v-if="isBrowserDevice">
      <modal v-if="showChoiceModal" @close="closeAllModals" :closeNavButton="true">
        <div slot="body">
            <auth-choice 
              @buyAnonymously="closeChoiceModal"
              @startRegister="openRegister"
              @startLogin="openLogin"
              ></auth-choice>
        </div>
      </modal>

      <modal v-if="showLoginModal"
        class="max-h-10"
        @close="closeAllModals"
        @back="openChoiceModal"
        :backNavButton="true"
        :closeNavButton="true">
        <div slot="body">
            <login 
              @loggedIn="loginDone" 
              @closeAllModals="closeAllModals" 
              @restorePassword="restorePasswordModal"
              @openRegister="openRegister"/>
        </div>
      </modal>

      <modal class="max-h-10" v-if="showRestorePasswordModal"
        @close="closeAllModals"
        @back="openLogin"
        :backNavButton="true"
        :closeNavButton="true">
        <div slot="title">
            {{ $t('auth.login.restore_password') }}
        </div>
        <div slot="body">
          <restore-password />
        </div>
      </modal>

      <modal v-if="showRegisterModal"
        @close="closeAllModals"
        @back="openChoiceModal"
        :backNavButton="true"
        :closeNavButton="true">
        <div slot="body">
            <register 
              @startLogin="openLogin"
              @closeAllModals="openLogin" />
        </div>
      </modal>

    </div>
</template>

<script>
  import Modal from "@/components/common/modal"
  import AuthChoice from "@/components/auth/auth-choice"
  import Login from "@/components/auth/login"
  import RestorePassword from "@/components/auth/restore-password"
  import Register from "@/components/auth/register"
  import { isBrowserDevice } from '@/helpers/deviceHelpers'

  export default {
    name: "auth-form",
    data() {
      return {
        showChoiceModal: true,
        showLoginModal: false,
        showRegisterModal: false,
        showRestorePasswordModal: false
      };
    },
    computed: {
      isBrowserDevice: function () {
        return isBrowserDevice();
      }
    },
    components : {
      AuthChoice,
      Modal,
      Login,
      RestorePassword,
      Register
    },
    methods: {
      closeChoiceModal() {
        this.showChoiceModal = false
        this.showLoginModal = false
        this.showRegisterModal = false
        this.showRestorePasswordModal = false
      },
      openChoiceModal() {
        this.showChoiceModal = true
        this.showLoginModal = false
        this.showRegisterModal = false
        this.showRestorePasswordModal = false
      },
      openLogin() {
        this.closeChoiceModal()
        this.showLoginModal = true
        this.showRegisterModal = false
        this.showRestorePasswordModal = false
      },
      openRegister() {
        this.closeChoiceModal()
        this.showLoginModal = false
        this.showRegisterModal = true
        this.showRestorePasswordModal = false
      },
      loginDone() {
        this.$emit('loggedIn')
      },
      restorePasswordModal() {
        this.closeChoiceModal()
        this.showRestorePasswordModal = true
      },
      closeAllModals() {
        this.closeChoiceModal();
      }
    }
  };
</script>

<style>
  .auth-title {
    @apply text-center text-primary text-xl
  }

  hr {
    /* border-bottom: 1px solid #c9c9c9; */
    color: #c9c9c9;
  }
</style>
